import { createSlice } from '@reduxjs/toolkit';
import { addNewCountry, editCountry, editCountryImage, getAllCountries } from './countriesService';

const initialState = {
  allCountries: {
    isCountriesLoading: null,
    isCountriesSuccess: null,
    countrysMessage: null,
    pageCount: 0,
    countries: [],
  },
  newCountry: {
    isCountryCreating: null,
    isCountryCreated: null,
    countryCreationMsg: null,
  },

  editedCountry: {
    isEditingCountry: null,
    isCountryEdited: null,
    countryEditedMsg: null
  },

  editedCountryImage: {
    isEditingCountryImage: null,
    isCountryImageEdited: null,
    countryImageEditedMsg: null
  }
};

const countrysSlice = createSlice({
  name: 'country',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllCountries.pending, (state) => {
        state.allCountries = {
          ...initialState.allCountries, // Reset to initial state
          isCountriesLoading: true,
          countrysMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllCountries.rejected, (state, action) => {
        state.allCountries = {
          ...initialState.allCountries,
          isCountriesLoading: false,
          isCountriesSuccess: false,
          countrysMessage: action.payload || 'Error occurred while fetching countries',
        };
      })

      // FULFILLED
      .addCase(getAllCountries.fulfilled, (state, action) => {
        state.allCountries = {
          ...initialState.allCountries,
          isCountriesLoading: false,
          isCountriesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          countries: action.payload.data || [],
        };
      });

    //Country creating
    builder
      .addCase(addNewCountry.pending, (state) => {
        state.newCountry = {
          ...initialState.newCountry, // Reset to initial state
          isCountryCreating: true,
          countryCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewCountry.rejected, (state, action) => {
        state.newCountry = {
          ...initialState.newCountry,
          isCountryCreating: false,
          isCountryCreated: false,
          countryCreationMsg: action.payload || 'Error occurred while creating the country.',
        };
      })

      // FULFILLED
      .addCase(addNewCountry.fulfilled, (state, action) => {
        state.newCountry = {
          ...initialState.newCountry,
          isCountryCreating: false,
          isCountryCreated: true,
          countryCreationMsg: action.payload || 'Successfully created the country.',
        };
      });

    //Country editing
    builder
      .addCase(editCountry.pending, (state) => {
        state.editedCountry = {
          ...initialState.editedCountry, // Reset to initial state
          isEditingCountry: true,
          countryEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editCountry.rejected, (state, action) => {
        state.editedCountry = {
          ...initialState.editedCountry, // Reset to initial state
          isEditingCountry: false,
          isCountryEdited: false,
          countryEditedMsg: action.payload || 'Error occurred while editing the country.',
        };
      })

      // FULFILLED
      .addCase(editCountry.fulfilled, (state, action) => {
        state.editedCountry = {
          ...initialState.editedCountry, // Reset to initial state
          isEditingCountry: false,
          isCountryEdited: true,
          countryEditedMsg: action.payload || 'Successfully edited the country.',
        };
      });

    //Country image editing
    builder
      .addCase(editCountryImage.pending, (state) => {
        state.editedCountryImage = {
          ...initialState.editedCountryImage, // Reset to initial state
          isEditingCountryImage: true,
          countryImageEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editCountryImage.rejected, (state, action) => {
        state.editedCountryImage = {
          ...initialState.editedCountryImage, // Reset to initial state
          isEditingCountryImage: false,
          isCountryImageEdited: false,
          countryImageEditedMsg: action.payload || 'Error occurred while editing the country image.',
        };
      })

      // FULFILLED
      .addCase(editCountryImage.fulfilled, (state, action) => {
        state.editedCountryImage = {
          ...initialState.editedCountryImage, // Reset to initial state
          isEditingCountryImage: false,
          isCountryImageEdited: false,
          countryImageEditedMsg: action.payload || 'Successfully edited the country image.',
        };
      });
  },
});

export default countrysSlice.reducer;
